import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FormUtilsService {

  constructor() { }

  trimFormValues(formValue: any): any {
    if (typeof formValue === 'object' && formValue !== null) {
      const trimmedValue: any = {};
      for (const key in formValue) {
        if (formValue.hasOwnProperty(key)) {
          if (typeof formValue[key] === 'string') {
            trimmedValue[key] = formValue[key].trim();
          } else if (Array.isArray(formValue[key])) {
            trimmedValue[key] = formValue[key].map(item => this.trimFormValues(item));
          } else if (typeof formValue[key] === 'object') {
            trimmedValue[key] = this.trimFormValues(formValue[key]);
          } else {
            trimmedValue[key] = formValue[key];
          }
        }
      }
      return trimmedValue;
    }
    return formValue;
  }

}
